import { Component } from '@angular/core';
import { OmpHeadingSize, OmpInstagramLayout } from '../../../_models';
import { OmpPillButtonStyleOptions } from '../../order-management-portal.sections';
import { OmpSectionSettings } from '..';

@Component({
  selector: 'omp-instagram-settings',
  templateUrl: './instagram-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpInstagramSettingsComponent extends OmpSectionSettings {
  public headingSize = OmpHeadingSize;
  public layout = OmpInstagramLayout;
  public styleOptions = OmpPillButtonStyleOptions;

}
